import { END_POINTS } from "../constants/url";
import { CommonBody } from "../types/General";
import emptySplitApi from "../utils/rtk";
type CommonResponseType = {
  statusCode: number;
  message: string;
};

export const userApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getCustomer: builder.query<
      CommonResponseType & { data: any },
      {
        from: number;
        search: string;
        role: string;
        size: number;
        accountStatus?: string;
        country?:string
      }
    >({
      query: ({ from, search, role, size, accountStatus, country }) => {
        const trimmedSearch = (search || "").trim();
        const params: string[] = [
          `size=${size}`,
          `from=${from}`,
          `role=${role}`,
        ];
        if (trimmedSearch.length) {
          params.push(`search=${trimmedSearch}`);
        }
        if (country && country.length) {
          params.push(`country=${country}`);
        }
        if (role === "OWNER" && accountStatus) {
          params.push(`accountStatus=${accountStatus}`);
        }
        return {
          url: `${END_POINTS.user}?${params.join("&")}`,
          method: "GET",
        };
      },
    }),
    addUser: builder.mutation<
      CommonResponseType & { data: any },
      { body: CommonBody }
    >({
      query: ({ body }) => ({
        url: END_POINTS.user,
        method: "POST",
        body,
      }),
    }),
    updateUser: builder.mutation<
      CommonResponseType & { data: any },
      { body: any; id: string }
    >({
      query: ({ body, id }) => ({
        url: `${END_POINTS.user}/${id}`,
        method: "PUT",
        body,
      }),
    }),
    updateStatus: builder.mutation<
      CommonResponseType & { data: any },
      { body: any; id: string }
    >({
      query: ({ body, id }) => ({
        url: `${END_POINTS.user}/${id}`,
        method: "PATCH",
        body,
      }),
    }),
    getUsersById: builder.query<
      CommonResponseType & { data: any },
      { id: string }
    >({
      query: ({ id }) => ({
        url: `${END_POINTS.user}/${id}`,
        method: "GET",
      }),
    }),
    deleteUserById: builder.mutation<CommonResponseType, { id: string }>({
      query: ({ id }) => ({
        url: `${END_POINTS.user}/${id}`,
        method: "DELETE",
      }),
    }),

    getUserCSV: builder.query<
      CommonResponseType & { data: string },
      {
        search: string;
      }
    >({
      query: ({ search }) => {
        let url = END_POINTS.user;
        const queryParams = [];
        if (search) {
          queryParams.push(`search=${search}`);
        }
        if (queryParams.length > 0) {
          url += `?${queryParams.join("&")}`;
        }
        return {
          url: url,
          method: "GET",
        };
      },
    }),
  }),
});

export const {
  useAddUserMutation,
  useDeleteUserByIdMutation,
  useLazyGetCustomerQuery,
  useLazyGetUsersByIdQuery,
  useUpdateUserMutation,
  useUpdateStatusMutation,
} = userApi;
